import TermDefs from 'term_defs';

const termsSorter = (a, b) => {
	const cyclesA = a.term.numCycles;
	const cyclesB = b.term.numCycles;
	if (cyclesA > cyclesB) return 1;
	if (cyclesB > cyclesA) return -1;
	return 0;
};

/**
 * From what the server sends to what the component needs
 * @returns {Array}
 */
const transformSubscriptionTerms = ({
	termPrices,
	billing,
}) => {
	// Sort by number of cycles to prevent 3-mo from appearing first
	const sortedTerms = termPrices.sort(termsSorter);

	const termBlobs = sortedTerms.map((t, index) => {
		const termBlob = TermDefs.getTermBlob(billing.rebillMonths || null, billing.rebillWeeks || null, t.term.numCycles);
		return {
			...termBlob,
			...t,
			// If most popular definition changes, this also needs to be updated in product_lv_map.get_recommended_term_price_map
			// so pricing stays consistent in product data feeds (GoData)
			mostPop: index === 1 && termPrices.length > 1,
		};
	});

	// Pre-Select the "Most Popular Box here"
	const recommendedTerm = termBlobs.find(t => t.mostPop) || termBlobs[0];

	return [termBlobs, recommendedTerm];
};

export default transformSubscriptionTerms;
